import React from "react";
import '../../assets/css/404/Content.css';

const NotFoundContent = () => {
    return (
        <>
            <div className="mainContainer">
                <div title="❤️ | Oh no! I hope you find your way back <3.">
                    <h1 className="notfound-title">404</h1>
                    <h2 className="notfound-message">Page not found</h2>
                    <p className="notfound-message">Sorry, the page you are looking for does not exist or has been moved.</p>
                    <img draggable="false" src="https://cdn.jaquesbot.fr/static/website_404.webp" title="❤️ | You are lost, here is a troll face to comfort you!" alt="Troll Face, because user have to be reconforted, he's lost !"/>
                </div>
            </div>
        </>
    );
};

export default NotFoundContent;
